export const HOCKEY_GROUP_MATCHES = {
  groupA: [
    {
      id: 511722,
      date: '2022-05-13T13:20:00.000Z',
      localTeam: {
        name: 'Франция',
        countryCode: 'FR',
        score: 2
      },
      visitorTeam: {
        name: 'Словакия',
        countryCode: 'SK',
        score: 4
      }
    },
    {
      id: 502453,
      date: '2022-05-13T17:20:00.000Z',
      localTeam: {
        name: 'Германия',
        countryCode: 'DE',
        score: 3
      },
      visitorTeam: {
        name: 'Канада',
        countryCode: 'CA',
        score: 5
      }
    },
    {
      id: 502454,
      date: '2022-05-14T09:20:00.000Z',
      localTeam: {
        name: 'Дания',
        countryCode: 'DK',
        score: 9
      },
      visitorTeam: {
        name: 'Казахстан',
        countryCode: 'KZ',
        score: 1
      }
    },
    {
      id: 502457,
      date: '2022-05-14T13:20:00.000Z',
      localTeam: {
        name: 'Швейцария',
        countryCode: 'CH',
        score: 5
      },
      visitorTeam: {
        name: 'Италия',
        countryCode: 'IT',
        score: 2
      }
    },
    {
      id: 502459,
      date: '2022-05-14T17:20:00.000Z',
      localTeam: {
        name: 'Словакия',
        countryCode: 'SK',
        score: 1
      },
      visitorTeam: {
        name: 'Германия',
        countryCode: 'DE',
        score: 2
      }
    },
    {
      id: 502460,
      date: '2022-05-15T09:20:00.000Z',
      localTeam: {
        name: 'Италия',
        countryCode: 'IT',
        score: 1
      },
      visitorTeam: {
        name: 'Канада',
        countryCode: 'CA',
        score: 6
      }
    },
    {
      id: 511725,
      date: '2022-05-15T13:20:00.000Z',
      localTeam: {
        name: 'Франция',
        countryCode: 'FR',
        score: 2
      },
      visitorTeam: {
        name: 'Казахстан',
        countryCode: 'KZ',
        score: 1
      }
    },
    {
      id: 502465,
      date: '2022-05-15T17:20:00.000Z',
      localTeam: {
        name: 'Дания',
        countryCode: 'DK',
        score: 0
      },
      visitorTeam: {
        name: 'Швейцария',
        countryCode: 'CH',
        score: 6
      }
    },
    {
      id: 502467,
      date: '2022-05-16T13:20:00.000Z',
      localTeam: {
        name: 'Словакия',
        countryCode: 'SK',
        score: 1
      },
      visitorTeam: {
        name: 'Канада',
        countryCode: 'CA',
        score: 5
      }
    },
    {
      id: 511726,
      date: '2022-05-16T17:20:00.000Z',
      localTeam: {
        name: 'Франция',
        countryCode: 'FR',
        score: 2
      },
      visitorTeam: {
        name: 'Германия',
        countryCode: 'DE',
        score: 3
      }
    },
    {
      id: 502471,
      date: '2022-05-17T13:20:00.000Z',
      localTeam: {
        name: 'Италия',
        countryCode: 'IT',
        score: 1
      },
      visitorTeam: {
        name: 'Дания',
        countryCode: 'DK',
        score: 2
      }
    },
    {
      id: 502473,
      date: '2022-05-17T17:20:00.000Z',
      localTeam: {
        name: 'Швейцария',
        countryCode: 'CH',
        score: 3
      },
      visitorTeam: {
        name: 'Казахстан',
        countryCode: 'KZ',
        score: 2
      }
    },
    {
      id: 511729,
      date: '2022-05-18T13:20:00.000Z',
      localTeam: {
        name: 'Франция',
        countryCode: 'FR',
        score: 2
      },
      visitorTeam: {
        name: 'Италия',
        countryCode: 'IT',
        score: 1
      }
    },
    {
      id: 502477,
      date: '2022-05-18T17:20:00.000Z',
      localTeam: {
        name: 'Швейцария',
        countryCode: 'CH',
        score: 5
      },
      visitorTeam: {
        name: 'Словакия',
        countryCode: 'SK',
        score: 3
      }
    },
    {
      id: 502478,
      date: '2022-05-19T15:00:00.000Z',
      localTeam: {
        name: 'Германия',
        countryCode: 'DE',
        score: 1
      },
      visitorTeam: {
        name: 'Дания',
        countryCode: 'DK',
        score: 0
      }
    },
    {
      id: 502480,
      date: '2022-05-19T18:30:00.000Z',
      localTeam: {
        name: 'Канада',
        countryCode: 'CA',
        score: 6
      },
      visitorTeam: {
        name: 'Казахстан',
        countryCode: 'KZ',
        score: 3
      }
    },
    {
      id: 502482,
      date: '2022-05-20T13:20:00.000Z',
      localTeam: {
        name: 'Германия',
        countryCode: 'DE',
        score: 9
      },
      visitorTeam: {
        name: 'Италия',
        countryCode: 'IT',
        score: 4
      }
    },
    {
      id: 502484,
      date: '2022-05-20T17:20:00.000Z',
      localTeam: {
        name: 'Казахстан',
        countryCode: 'KZ',
        score: 3
      },
      visitorTeam: {
        name: 'Словакия',
        countryCode: 'SK',
        score: 4
      }
    },
    {
      id: 511731,
      date: '2022-05-21T09:20:00.000Z',
      localTeam: {
        name: 'Дания',
        countryCode: 'DK',
        score: 3
      },
      visitorTeam: {
        name: 'Франция',
        countryCode: 'FR',
        score: 0
      }
    },
    {
      id: 502489,
      date: '2022-05-21T13:20:00.000Z',
      localTeam: {
        name: 'Канада',
        countryCode: 'CA',
        score: 3
      },
      visitorTeam: {
        name: 'Швейцария',
        countryCode: 'CH',
        score: 6
      }
    },
    {
      id: 502490,
      date: '2022-05-21T17:20:00.000Z',
      localTeam: {
        name: 'Италия',
        countryCode: 'IT',
        score: 1
      },
      visitorTeam: {
        name: 'Словакия',
        countryCode: 'SK',
        score: 3
      }
    },
    {
      id: 502493,
      date: '2022-05-22T13:20:00.000Z',
      localTeam: {
        name: 'Казахстан',
        countryCode: 'KZ',
        score: 4
      },
      visitorTeam: {
        name: 'Германия',
        countryCode: 'DE',
        score: 5
      }
    },
    {
      id: 511735,
      date: '2022-05-22T17:20:00.000Z',
      localTeam: {
        name: 'Швейцария',
        countryCode: 'CH',
        score: 5
      },
      visitorTeam: {
        name: 'Франция',
        countryCode: 'FR',
        score: 2
      }
    },
    {
      id: 502496,
      date: '2022-05-23T13:20:00.000Z',
      localTeam: {
        name: 'Казахстан',
        countryCode: 'KZ',
        score: 5
      },
      visitorTeam: {
        name: 'Италия',
        countryCode: 'IT',
        score: 2
      }
    },
    {
      id: 502499,
      date: '2022-05-23T17:20:00.000Z',
      localTeam: {
        name: 'Канада',
        countryCode: 'CA',
        score: 2
      },
      visitorTeam: {
        name: 'Дания',
        countryCode: 'DK',
        score: 3
      }
    },
    {
      id: 502500,
      date: '2022-05-24T09:20:00.000Z',
      localTeam: {
        name: 'Германия',
        countryCode: 'DE',
        score: 3
      },
      visitorTeam: {
        name: 'Швейцария',
        countryCode: 'CH',
        score: 4
      }
    },
    {
      id: 502502,
      date: '2022-05-24T13:20:00.000Z',
      localTeam: {
        name: 'Словакия',
        countryCode: 'SK',
        score: 7
      },
      visitorTeam: {
        name: 'Дания',
        countryCode: 'DK',
        score: 1
      }
    },
    {
      id: 511734,
      date: '2022-05-24T17:20:00.000Z',
      localTeam: {
        name: 'Канада',
        countryCode: 'CA',
        score: 7
      },
      visitorTeam: {
        name: 'Франция',
        countryCode: 'FR',
        score: 1
      }
    }
  ],
  groupB: [
    {
      id: 502451,
      date: '2022-05-13T13:20:00.000Z',
      localTeam: {
        name: 'США',
        countryCode: 'US',
        score: 4
      },
      visitorTeam: {
        name: 'Латвия',
        countryCode: 'LV',
        score: 1
      }
    },
    {
      id: 502452,
      date: '2022-05-13T17:20:00.000Z',
      localTeam: {
        name: 'Финляндия',
        countryCode: 'FI',
        score: 5
      },
      visitorTeam: {
        name: 'Норвегия',
        countryCode: 'NO',
        score: 0
      }
    },
    {
      id: 511723,
      date: '2022-05-14T09:20:00.000Z',
      localTeam: {
        name: 'Швеция',
        countryCode: 'SE',
        score: 3
      },
      visitorTeam: {
        name: 'Австрия',
        countryCode: 'AT',
        score: 1
      }
    },
    {
      id: 502456,
      date: '2022-05-14T13:20:00.000Z',
      localTeam: {
        name: 'Чехия',
        countryCode: 'CZ',
        score: 5
      },
      visitorTeam: {
        name: 'Англия',
        countryCode: 'GB-ENG',
        score: 1
      }
    },
    {
      id: 502458,
      date: '2022-05-14T17:20:00.000Z',
      localTeam: {
        name: 'Латвия',
        countryCode: 'LV',
        score: 1
      },
      visitorTeam: {
        name: 'Финляндия',
        countryCode: 'FI',
        score: 2
      }
    },
    {
      id: 502461,
      date: '2022-05-15T09:20:00.000Z',
      localTeam: {
        name: 'Норвегия',
        countryCode: 'NO',
        score: 4
      },
      visitorTeam: {
        name: 'Англия',
        countryCode: 'GB-ENG',
        score: 3
      }
    },
    {
      id: 511724,
      date: '2022-05-15T13:20:00.000Z',
      localTeam: {
        name: 'Австрия',
        countryCode: 'AT',
        score: 2
      },
      visitorTeam: {
        name: 'США',
        countryCode: 'US',
        score: 3
      }
    },
    {
      id: 502464,
      date: '2022-05-15T17:20:00.000Z',
      localTeam: {
        name: 'Чехия',
        countryCode: 'CZ',
        score: 3
      },
      visitorTeam: {
        name: 'Швеция',
        countryCode: 'SE',
        score: 5
      }
    },
    {
      id: 502466,
      date: '2022-05-16T13:20:00.000Z',
      localTeam: {
        name: 'Латвия',
        countryCode: 'LV',
        score: 3
      },
      visitorTeam: {
        name: 'Норвегия',
        countryCode: 'NO',
        score: 2
      }
    },
    {
      id: 502468,
      date: '2022-05-16T17:20:00.000Z',
      localTeam: {
        name: 'Финляндия',
        countryCode: 'FI',
        score: 4
      },
      visitorTeam: {
        name: 'США',
        countryCode: 'US',
        score: 1
      }
    },
    {
      id: 511727,
      date: '2022-05-17T13:20:00.000Z',
      localTeam: {
        name: 'Чехия',
        countryCode: 'CZ',
        score: 1
      },
      visitorTeam: {
        name: 'Австрия',
        countryCode: 'AT',
        score: 2
      }
    },
    {
      id: 502472,
      date: '2022-05-17T17:20:00.000Z',
      localTeam: {
        name: 'Швеция',
        countryCode: 'SE',
        score: 6
      },
      visitorTeam: {
        name: 'Англия',
        countryCode: 'GB-ENG',
        score: 0
      }
    },
    {
      id: 511728,
      date: '2022-05-18T13:20:00.000Z',
      localTeam: {
        name: 'Норвегия',
        countryCode: 'NO',
        score: 5
      },
      visitorTeam: {
        name: 'Австрия',
        countryCode: 'AT',
        score: 3
      }
    },
    {
      id: 502476,
      date: '2022-05-18T17:20:00.000Z',
      localTeam: {
        name: 'Финляндия',
        countryCode: 'FI',
        score: 2
      },
      visitorTeam: {
        name: 'Швеция',
        countryCode: 'SE',
        score: 3
      }
    },
    {
      id: 502479,
      date: '2022-05-19T13:20:00.000Z',
      localTeam: {
        name: 'Англия',
        countryCode: 'GB-ENG',
        score: 0
      },
      visitorTeam: {
        name: 'США',
        countryCode: 'US',
        score: 3
      }
    },
    {
      id: 502481,
      date: '2022-05-19T17:20:00.000Z',
      localTeam: {
        name: 'Чехия',
        countryCode: 'CZ',
        score: 5
      },
      visitorTeam: {
        name: 'Латвия',
        countryCode: 'LV',
        score: 1
      }
    },
    {
      id: 502483,
      date: '2022-05-20T13:20:00.000Z',
      localTeam: {
        name: 'Англия',
        countryCode: 'GB-ENG',
        score: 0
      },
      visitorTeam: {
        name: 'Финляндия',
        countryCode: 'FI',
        score: 6
      }
    },
    {
      id: 511730,
      date: '2022-05-20T17:20:00.000Z',
      localTeam: {
        name: 'Латвия',
        countryCode: 'LV',
        score: 4
      },
      visitorTeam: {
        name: 'Австрия',
        countryCode: 'AT',
        score: 3
      }
    },
    {
      id: 502487,
      date: '2022-05-21T09:20:00.000Z',
      localTeam: {
        name: 'США',
        countryCode: 'US',
        score: 3
      },
      visitorTeam: {
        name: 'Швеция',
        countryCode: 'SE',
        score: 2
      }
    },
    {
      id: 511732,
      date: '2022-05-21T13:20:00.000Z',
      localTeam: {
        name: 'Австрия',
        countryCode: 'AT',
        score: 0
      },
      visitorTeam: {
        name: 'Финляндия',
        countryCode: 'FI',
        score: 3
      }
    },
    {
      id: 502491,
      date: '2022-05-21T17:20:00.000Z',
      localTeam: {
        name: 'Норвегия',
        countryCode: 'NO',
        score: 1
      },
      visitorTeam: {
        name: 'Чехия',
        countryCode: 'CZ',
        score: 4
      }
    },
    {
      id: 502492,
      date: '2022-05-22T13:20:00.000Z',
      localTeam: {
        name: 'Англия',
        countryCode: 'GB-ENG',
        score: 3
      },
      visitorTeam: {
        name: 'Латвия',
        countryCode: 'LV',
        score: 4
      }
    },
    {
      id: 502494,
      date: '2022-05-22T17:20:00.000Z',
      localTeam: {
        name: 'Швеция',
        countryCode: 'SE',
        score: 7
      },
      visitorTeam: {
        name: 'Норвегия',
        countryCode: 'NO',
        score: 1
      }
    },
    {
      id: 502497,
      date: '2022-05-23T13:20:00.000Z',
      localTeam: {
        name: 'США',
        countryCode: 'US',
        score: 0
      },
      visitorTeam: {
        name: 'Чехия',
        countryCode: 'CZ',
        score: 1
      }
    },
    {
      id: 511733,
      date: '2022-05-23T17:20:00.000Z',
      localTeam: {
        name: 'Австрия',
        countryCode: 'AT',
        score: 5
      },
      visitorTeam: {
        name: 'Англия',
        countryCode: 'GB-ENG',
        score: 3
      }
    },
    {
      id: 502501,
      date: '2022-05-24T09:20:00.000Z',
      localTeam: {
        name: 'Швеция',
        countryCode: 'SE',
        score: 1
      },
      visitorTeam: {
        name: 'Латвия',
        countryCode: 'LV',
        score: 0
      }
    },
    {
      id: 502503,
      date: '2022-05-24T13:20:00.000Z',
      localTeam: {
        name: 'США',
        countryCode: 'US',
        score: 4
      },
      visitorTeam: {
        name: 'Норвегия',
        countryCode: 'NO',
        score: 2
      }
    },
    {
      id: 502505,
      date: '2022-05-24T17:20:00.000Z',
      localTeam: {
        name: 'Финляндия',
        countryCode: 'FI',
        score: 3
      },
      visitorTeam: {
        name: 'Чехия',
        countryCode: 'CZ',
        score: 0
      }
    }
  ]
};
